var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 14.9167V37.0834C11.75 39.7117 18.0833 41.8334 26 41.8334C33.9167 41.8334 40.25 39.7117 40.25 37.0834V14.9167",
    fill: "url(#paint0_linear_7240_24517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19.6667C33.8701 19.6667 40.25 17.5401 40.25 14.9167C40.25 12.2934 33.8701 10.1667 26 10.1667C18.1299 10.1667 11.75 12.2934 11.75 14.9167C11.75 17.5401 18.1299 19.6667 26 19.6667Z",
    fill: "#BBBDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 26C40.25 28.6283 33.9167 30.75 26 30.75C18.0833 30.75 11.75 28.6283 11.75 26",
    stroke: "url(#paint1_linear_7240_24517)",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 47.8197C26.0006 48.7346 25.2579 49.4824 24.3453 49.4179C19.9445 49.1069 15.708 47.5606 12.1306 44.9409C8.10643 41.9941 5.1254 37.8422 3.61969 33.0872C2.11398 28.3321 2.16185 23.2211 3.75637 18.4951C5.35089 13.7691 8.40917 9.67374 12.4878 6.80282C16.5665 3.9319 21.4535 2.43461 26.4404 2.52804C31.4272 2.62148 36.2547 4.30076 40.223 7.32245C44.1912 10.3441 47.094 14.5511 48.5103 19.3336C49.7695 23.5851 49.7958 28.0949 48.6038 32.3425C48.3567 33.2234 47.4021 33.6703 46.5409 33.3616C45.6796 33.0529 45.2387 32.1057 45.4757 31.222C46.4362 27.64 46.3927 23.8508 45.3335 20.2744C44.117 16.167 41.624 12.5537 38.2158 9.95845C34.8076 7.36322 30.6614 5.92093 26.3783 5.84069C22.0952 5.76044 17.8979 7.04641 14.3949 9.51216C10.8919 11.9779 8.26521 15.4953 6.89572 19.5543C5.52624 23.6133 5.48513 28.003 6.77833 32.087C8.07154 36.1709 10.6319 39.7369 14.0881 42.2678C17.0974 44.4715 20.6498 45.7908 24.3458 46.0951C25.2576 46.1702 26.0006 46.9048 26.0006 47.8197Z",
    fill: "url(#paint2_angular_7240_24517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24517",
    x1: 12.5417,
    y1: 15.7084,
    x2: 41.0417,
    y2: 44.2084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C891E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2925FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24517",
    x1: 26,
    y1: 27.5833,
    x2: 26,
    y2: 32.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD55FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_7240_24517",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0006 26.0001) rotate(90) scale(23.4762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C92FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecover);
export default __webpack_public_path__ + "static/media/icon_recover.141cee8f1e7119ecfb7994d191342350.svg";
export { ForwardRef as ReactComponent };